import type { RawTransaction } from './raw-transaction';

/** Render the exact imported payload, including empty calldata for native sends. */
export function ImportedTransactionPreview({
  transaction,
}: {
  transaction: RawTransaction;
}): React.ReactElement {
  return (
    <dl className="grid gap-2 text-sm sm:grid-cols-[72px_minmax(0,1fr)]">
      <dt className="text-muted-foreground">To</dt>
      <dd className="break-all font-mono text-xs">{transaction.to}</dd>
      <dt className="text-muted-foreground">Value</dt>
      <dd className="break-all font-mono text-xs">{transaction.value} wei</dd>
      <dt className="text-muted-foreground">Data</dt>
      <dd className="min-w-0">
        {transaction.data === '0x' ? (
          <span className="font-mono text-xs">0x (native send)</span>
        ) : (
          <details>
            <summary className="cursor-pointer font-mono text-xs">
              {transaction.data.slice(0, 10)} ·{' '}
              {(transaction.data.length - 2) / 2} bytes
            </summary>
            <pre className="mt-2 max-h-40 overflow-auto whitespace-pre-wrap break-all rounded-md bg-muted p-3 text-xs">
              {transaction.data}
            </pre>
          </details>
        )}
      </dd>
    </dl>
  );
}
